import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX } from '../../constants'

import './style.scss'

export default class ControlRow extends Component {
    static propTypes = {
        activeAddress: PropTypes.object.isRequired,
        handleCheckBoxChange: PropTypes.func.isRequired,
        showBranch: PropTypes.bool,
        showRegistered: PropTypes.bool,
        showShops: PropTypes.bool,
    }

    render() {
        const { activeAddress, showBranch, showRegistered, showShops, handleCheckBoxChange } = this.props

        return (
            <div className={'google-map-control-row'}>
                <div className={'control-wrapper'}>
                    <div className={'checkboxes'}>
                        <div className={'checkbox-container'}>
                            <label htmlFor={'registeredChkBox'} className={'registered-label'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.registered`} />
                            </label>
                            <input
                                type={'checkbox'}
                                name={'registeredChkBox'}
                                id={'registeredChkBox'}
                                onChange={(e) => handleCheckBoxChange(e, 'showRegistered')}
                                checked={showRegistered}
                            />
                        </div>
                        <div className={'checkbox-container'}>
                            <label htmlFor={'branchChkBox'} className={'branch-label'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.shops`} />
                            </label>
                            <input
                                type={'checkbox'}
                                name={'branchChkBox'}
                                id={'branchChkBox'}
                                onChange={(e) => handleCheckBoxChange(e, 'showShops')}
                                checked={showShops}
                            />
                        </div>
                        <div className={'checkbox-container'}>
                            <label htmlFor={'shopsChkBox'} className={'shops-label'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.branch`} />
                            </label>
                            <input
                                type={'checkbox'}
                                name={'shopsChkBox'}
                                id={'shopsChkBox'}
                                onChange={(e) => handleCheckBoxChange(e, 'showBranch')}
                                checked={showBranch}
                            />
                        </div>
                    </div>
                    <div className={'links'}>
                        <a
                            href={`https://www.google.com/maps/search/?api=1&query=${
                                activeAddress?.gpsX && activeAddress?.gpsY
                                    ? `${activeAddress?.gpsX} ${activeAddress?.gpsY}`
                                    : `${activeAddress?.value}`
                            }`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={'google-maps-link'}
                        >
                            <FormattedMessage id={`${LOCALE_PREFIX}.googleMaps`} />
                        </a>
                        <a
                            href={`https://mapy.cz/zakladni?q=${
                                activeAddress?.gpsX && activeAddress?.gpsY
                                    ? `${activeAddress?.gpsX} ${activeAddress?.gpsY}`
                                    : `${activeAddress?.value}`
                            }`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={'mapycz-link'}
                        >
                            <FormattedMessage id={`${LOCALE_PREFIX}.mapsCz`} />
                        </a>
                    </div>
                </div>
                <div className={'info-message'}>
                    <span className={'with-warning-icon'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.streetViewWarning`} />
                    </span>
                </div>
            </div>
        )
    }
}
